import { IconSettings } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import React, { useState } from 'react';
import {
    Dropdown, DropdownToggle, DropdownMenu, DropdownItem,
} from 'reactstrap';
import './DealGroupMenu.scss';

interface DealGroupMenuProps {
    onRename: () => void;
    onEditColor: () => void;
    onDelete: () => void;
}

const DealGroupMenu: React.FC<DealGroupMenuProps> = ({ onRename, onEditColor, onDelete }) => {
    const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    return (
        <Dropdown isOpen={isMenuOpen} toggle={toggleMenu} className="DealGroupMenu" direction="down">
            <DropdownToggle tag="div" className="DealGroupMenu__toggle p-2 m-1" data-testid="deal-group-menu-toggle">
                <NSIcon icon={IconSettings} size="sm" style={{ cursor: 'pointer' }} />
            </DropdownToggle>
            <DropdownMenu className="DealGroupMenu--dropdown-menu text-white" data-testid="deal-group-menu">
                <DropdownItem onClick={onRename} className="heap-deal-pipeline-rename-group">Rename group</DropdownItem>
                <DropdownItem onClick={onEditColor} className="heap-deal-pipeline-set-group-color">Set color</DropdownItem>
                <DropdownItem onClick={onDelete} className="heap-deal-pipeline-delete-group">Delete group</DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default DealGroupMenu;
